import { Component, inject, OnInit } from '@angular/core';
import {TranslationService} from "@lcms/shared/i18n";
import {languages , LanguageFlag} from '@client'
import {filter, startWith} from "rxjs";
import {NavigationEnd, Router} from "@angular/router";
import { Location } from '@angular/common';
declare  var $:any;

@Component({
  selector: 'lcms-swin-landing',
  templateUrl: './swin-landing.component.html',
  styleUrls: ['./swin-landing.component.scss'],
})
export class SwinLandingComponent implements OnInit {
  router= inject(Router)
  location = inject(Location)
  // routerSubscription: Subscription;
  // addHieght = false
  padding = false
  constructor(private translationService:TranslationService) {}
  langs = languages;
  language: LanguageFlag;
  currentRoute$ = this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    startWith(new NavigationEnd(0, this.router.url, this.router.url))
  );
  ngOnInit(): void {
    this.setLanguage(this.translationService.getSelectedLanguage());
    // this.checkUrl(this.router.url); // Vérifier l'URL immédiatement

    // this.routerSubscription = this.currentRoute$.subscribe((event : NavigationEnd) => {
    //   this.checkUrl(event.url);
    // });
    this.modalOpen()
  }
  // checkUrl(url: string) {
  //   this.addHieght = url.includes('forgot-password');
  // }
  addHieght(url: string) {
    return url.includes('forgot-password');
  }
  selectLanguage(lang: string) {
    this.translationService.setLanguage(lang);
    this.setLanguage(lang);
    // document.location.reload();
  }

  setLanguage(lang: string) {
    this.langs.forEach((language: LanguageFlag) => {
      if (language.lang === lang) {
        language.active = true;
        this.language = language;
      } else {
        language.active = false;
      }
    });
  }

  private modalOpen() {
    console.log("is open", localStorage.getItem('age'));
     if(localStorage.getItem('age')===null || localStorage.getItem('age')===undefined || localStorage.getItem('age') === 'false'){
    $('#modal').modal('show')
    }

  }
  confirmeAge(){
    localStorage.setItem('age','true')
    $('#modal').modal('hide')
  }
  refuseAge(){
    localStorage.setItem('age','false')
    this.location.back()
  }
}
